import React from "react";
import { useTranslation } from "react-i18next";
import { Store } from "lucide-react";

interface SourceRestaurantBadgeProps {
    restaurantName?: string;
    className?: string;
}

/**
 * "from {restaurant}" badge shown on cross-restaurant ingredient / subrecipe
 * rows (in the picker and the ingredients list). Renders nothing for
 * same-restaurant rows (no `restaurantName`).
 */
const SourceRestaurantBadge: React.FC<SourceRestaurantBadgeProps> = ({ restaurantName, className }) => {
    const { t } = useTranslation();
    if (!restaurantName) return null;
    return (
        <span
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[12px] font-medium bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-300 ${className ?? ''}`}
        >
            <Store className="w-3 h-3" />
            {t('costPrice.addIngredient.fromRestaurant', { restaurant: restaurantName })}
        </span>
    );
};

export default SourceRestaurantBadge;
